module.exports = __webpack_public_path__ + "static/media/sell_start_service_rent_4.ed2a5a06.jpg";